import * as React from 'react';
import { styles } from './styles';
import { Manager, Reference, Popper, PopperProps } from 'react-popper';
import NodeResolver from 'react-node-resolver';
import memoizeOne from 'memoize-one';
import { isEqual } from '@lib';
import { Subscription } from 'rxjs/internal/Subscription';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { filter } from 'rxjs/internal/operators/filter';
export interface InlineDialogProps<T> {
  closeOnOutsideClick: boolean;
  isOpen: boolean;
  children: JSX.Element;
  offset: number;
  triggerRef: HTMLElement | null;
  refContainer: React.ReactElement<any>;
  placement: PopperProps['placement'];
  onCloseRequest: (e: Event, contextData: T) => void;
  contextData: T;
}

type State = Readonly<{}>;

export class InlineDialog<T extends object | null> extends React.PureComponent<InlineDialogProps<T>, State> {
  static defaultProps = {
    offset: 8,
    closeOnOutsideClick: true,
    placement: 'bottom-start'
  };

  trigger: JSX.Element;
  triggerRef: HTMLElement | null;
  dialogRef: HTMLElement | null;
  private clickSub?: Subscription;

  // componentDidUpdate(prevProps: Props) {
  //   this.trigger = this.getTrigger(this.props);
  // }

  componentDidMount() {
    this.observeBackdropClick();
  }

  componentWillUnmount() {
    if (this.clickSub) {
      this.clickSub.unsubscribe();
    }
  }

  observeBackdropClick = () => {
    this.clickSub = fromEvent(window, 'click')
      .pipe(
        filter(e => {
          return (
            this.props.closeOnOutsideClick &&
            this.props.isOpen &&
            e.target instanceof Node &&
            !!this.props.triggerRef &&
            !!this.dialogRef &&
            (!this.props.triggerRef.contains(e.target) && !this.dialogRef.contains(e.target))
          );
        })
      )
      .subscribe(e => {
        this.props.onCloseRequest(e as any, this.props.contextData);
      });
  };

  getTrigger = memoizeOne((refContainer: InlineDialogProps<T>['refContainer']) => {
    return refContainer;
  }, isEqual);

  render(): React.ReactNode {
    // const refContainer = this.getTrigger(this.props.refContainer);
    return (
      <Manager>
        <Reference>
          {({ ref }) => (
            <NodeResolver
              innerRef={(el: HTMLElement | null) => {
                this.resolveTriggerNode(el);
                ref(el);
              }}
            >
              {this.props.refContainer}
            </NodeResolver>
          )}
        </Reference>
        {this.props.isOpen && (
          <Popper
            placement={this.props.placement}
            positionFixed={true}
            // modifiers={{
            //   keepTogether: {
            //     enabled: true
            //   },
            //   preventOverflow: {
            //     escapeWithReference: true,
            //     enabled: false,
            //     priority: ['bottom'],
            //     order: 0,
            //     boundariesElement: this.triggerRef!
            //   }
            // }}
          >
            {({ ref, style, placement, outOfBoundaries }) => {
              return (
                <div
                  ref={el => {
                    ref(el);
                    this.dialogRef = el;
                  }}
                  style={style}
                  className={styles.container(this.props.offset, !!outOfBoundaries)}
                  data-placement={placement}
                >
                  {this.props.children}
                </div>
              );
            }}
          </Popper>
        )}
      </Manager>
    );
  }

  private resolveTriggerNode = (el: HTMLElement | null) => {
    this.triggerRef = el;
  };
}
